import { render, staticRenderFns } from "./ReturnGoodsShow.vue?vue&type=template&id=7ea2d458&scoped=true"
import script from "./ReturnGoodsShow.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2d458",
  null
  
)

export default component.exports